import Vue from 'vue'
import { shortId, toCurrency, formatNumber } from '../utils/string'

Vue.filter('shortId', shortId)
Vue.filter('currency', toCurrency)
Vue.filter('formatNumber', formatNumber)
